// export const BACKEND_BASEURL = "https://quicktable.net/backend/";
export const BACKEND_BASEURL = process.env.REACT_APP_BACKEND_URL;
